export default {
  'Teklif Formu': '見積書',
  'Kayıtlı Teklifler': '保存された見積書',
  'Kullanıcı Adı': 'ユーザー名',
  'Şifre': 'パスワード',
  'Giriş Yap': 'ログイン',
  'Çıkış Yap': 'ログアウト',
  'KDV Oranı': '消費税率',
  'Teklif Durumu': '見積書ステータス',
  'Kaydet': '保存',
  'PDF Önizleme': 'PDFプレビュー',
  'PDF\'ye Aktar': 'PDFにエクスポート',
  'E-posta ile Gönder': 'メールで送信',
  'Alıcı': '受信者',
  'Tarih': '日付',
  'Genel Toplam': '合計',
  'Not': '備考',
  'KDV': '消費税',
  'Alt Toplam': '小計',
  'Açıklama': '説明',
  'Ürün Adı': '製品名',
  'SUT Kodu': 'SUTコード',
  'Birim Alış Fiyatı': '単価',
  'Sipariş Adedi': '注文数量',
  'Promosyon Ürün': 'プロモーション製品',
  'Toplam Adet': '総数量',
  'Sipariş Tutarı': '注文金額',
  'Durum': 'ステータス',
  'Kabul Edildi': '承認済み',
  'Reddedildi': '却下',
  'Gönderildi': '送信済み',
  'Taslak': '下書き',
  'Yurtiçi': '国内',
  'Yurtdışı': '国際',
  'Sipariş Oluştur': '注文作成',
  'Ürün Sıralaması': '製品ソート',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': '製品は人気度と重要度でソートされています',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': '心臓病学と血管外科製品が優先的に表示されています',
  'Ürün adı, açıklama veya barkod ile ara...': '製品名、説明、またはバーコードで検索...',
  'Tüm Kategoriler': 'すべてのカテゴリ',
  'Kutu görünüm': 'グリッドビュー',
  'Liste görünüm': 'リストビュー',
  'Aradığınız kriterlere uygun ürün bulunamadı': '検索条件に一致する製品が見つかりません',
  'Ürün Adı Yok': '製品名なし',
  'Kategori Yok': 'カテゴリなし',
  'Açıklama yok': '説明なし',
  'Firma Bilgilerini Doldurun': '会社情報を入力',
  'Sepete Ekle': 'カートに追加',
  'Firma Bilgileri': '会社情報',
  'Ülke Seçimi': '国選択',
  'Türkiye': 'トルコ',
  'Almanya': 'ドイツ',
  'ABD': 'アメリカ',
  'Firma Ünvanı': '会社名',
  'Vergi Dairesi': '税務署',
  'Vergi Numarası': '税番号',
  'Adres': '住所',
  'Şehir': '都市',
  'Şehir Seçimi': '都市選択',
  'Şehir Seçiniz': '都市を選択',
  'Şehir adı ara...': '都市名を検索...',
  'Aradığınız şehir bulunamadı': '都市が見つかりません',
  'Bu ülke için şehir verisi bulunamadı': 'この国に都市データがありません',
  'şehir bulundu': '{{count}}都市が見つかりました',
  'Yetkili': '担当者',
  'Telefon': '電話',
  'Email': 'メール',
  'Bilgileri İlet': '情報送信',
  'Lütfen eksik alanları doldurun': '不足している項目を入力してください',
  'Firma kaydedilemedi': '会社情報が保存されませんでした',
  'Firma bilgileri başarıyla iletildi': '会社情報が正常に送信されました',
  'Firma Ünvanı:': '会社名:',
  'Yetkili Kişi:': '担当者:',
  'Sepetiniz': 'あなたのカート',
  'Sepetiniz boş': 'あなたのカートは空です',
  'adet': '個',
  'Düzenle': '編集',
  'Kaldır': '削除',
  'Siparişi Tamamla': '注文完了',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'まず会社情報を完全に送信してください',
  'Sipariş başarıyla kaydedildi': '注文が正常に保存されました',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'ウェルカムメッセージとアクセスリンクがメールに送信されました',
  'Link 3 gün geçerlidir': 'リンクは3日間有効です',
  'Sipariş kaydedilemedi': '注文が保存されませんでした',
  'Firma Bilgileri Gerekli': '会社情報が必要',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'カートに追加するにはまず会社情報を入力してください',
  'Önce Bilgileri Doldurun': 'まず情報を入力',
  'Uyarı': '警告',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'カートに追加するにはまず会社情報を入力する必要があります',
  'SUT Kütüphanesi Tanımı': 'SUTライブラリ定義',
  'SUT Kodu:': 'SUTコード:',
  'Standart': '標準',
  'Açıklama (isteğe bağlı)': '説明（任意）',
  'Partner Ol': 'パートナーになる',
  'Partner başvuru popup açılacak': 'パートナー申請ポップアップが開きます',
  'Dil': '言語',
  'E-posta': 'メール',
  'E-Posta': 'メール',
  'Şifre': 'パスワード',
  'Şifremi Unuttum': 'パスワードを忘れた',
  'Giriş yapılıyor...': 'ログイン中...',
  'E-posta veya şifre hatalı': 'メールまたはパスワードが間違っています',
  'Şifre sıfırlama e-postası gönderildi': 'パスワードリセットメールが送信されました',
  'E-posta gönderilemedi': 'メールが送信されませんでした',
  'Üye Ol': '登録',
  'Üye Değil Misiniz?': 'メンバーではありませんか？',
  'Şimdi Üye Ol': '今すぐ登録',
  'Misafir Kullanıcı': 'ゲストユーザー',
  'Hızlı Sipariş': 'クイック注文',
  'Misafir Olarak Sipariş Verin': 'ゲストとして注文',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'ログインせずに製品を素早く選択して注文を作成',
  'Giriş yapmadan sipariş oluşturun': 'ログインせずに注文作成',
  'Anında Erişim': '即座アクセス',
  'Tüm ürünlere anında erişim': 'すべての製品に即座アクセス',
  'Güvenli İşlem': '安全な取引',
  'SSL korumalı güvenli sipariş': 'SSL保護の安全な注文',
  'Misafir Olarak Sipariş Oluştur': 'ゲストとして注文作成',
  'İpucu:': 'ヒント:',
  'Daha fazla özellik için üye olun': 'より多くの機能のために登録してください',
  'Ücretsiz': '無料',
  'Hızlı': '高速',
  'Güvenli': '安全',
  'bayilikSozlesme': 'INVAMEDパートナーシップの利用規約と条件を読み、同意します。',
  'geri': '戻る',
  'basvuruGonder': '申請送信',
  'ileri': '次へ',
  'sozlesmeGonderildi': '契約書がメールに送信されました！',
  'sozlesmeDesc': 'メールに送信されたINVAMEDパートナーシップ契約書と必要な書類を以下にアップロードしてください。',
  'tamamla': '申請完了',
  'basvuruAlindi': 'あなたの申請が受け取られました！',
  'basvuruAlindiDesc': 'INVAMEDチームがあなたの申請を検討し、できるだけ早く連絡いたします。',
  'Başvuru Durumu': '申請状況',
  'Başvurunuz onay sürecindedir': 'あなたの申請は審査中です',
  'sifreSifirla': 'パスワードリセット',
  'sifreSifirlaDesc': '登録されたメールアドレスを入力してください。パスワードリセットの手順をお送りします。',
  'gonder': '送信',
  'talimatGonderildi': '手順が送信されました',
  'sentDesc': 'パスワードリセットの手順が <b>{email}</b> に送信されました。メールをご確認ください。',
  'helpTitle': 'ログイン方法は？',
  'helpList': [
    'INVAMEDディストリビューターパネルにログインするには、登録されたメールアドレスとパスワードを入力してください。',
    'デモユーザーでログインするには：',
    'パスワードを忘れた場合は、「パスワードを忘れた」リンクを使用してリセットをリクエストしてください。',
    'ログインに問題がある場合は、メールアドレスとパスワードが正しいことを確認してください。問題が続く場合は、サポートチームにお問い合わせください。'
  ],
  'partnerlikSozlesmeTitle': 'INVAMEDパートナーシップ契約と条件',
  'partnerlikSozlesmeText': `1. 一般規定

この契約は、医療機器および機器の販売における協力のために、INVAMED（以下「会社」）とパートナー候補者（以下「パートナー」）の間で締結されます。

2. パートナーシップ条件

2.1. パートナーは医療機器の販売に関する法的権限を持たなければなりません。
2.2. パートナーは医療分野で活動する組織でなければなりません。
2.3. パートナーは必要なライセンスと証明書を持たなければなりません。
2.4. パートナーは財務的に信頼できるものでなければなりません。

3. 当事者の義務

会社の義務：
3.1. 質の高い製品とサービスを提供する
3.2. 技術サポートを提供する
3.3. トレーニングと情報を提供する
3.4. 価格設定において透明性を保つ

パートナーの義務：
3.1. 製品を適切な条件で保管する
3.2. 質の高い顧客サービスを提供する
3.3. 法的規制を遵守する
3.4. 会社のブランドを保護する

4. 価格設定と支払い

4.1. 価格は会社によって決定される
4.2. パートナーは決定された価格を維持する義務がある
4.3. 支払い条件は別途決定される
4.4. 手数料率は実績に応じて変動する場合がある

5. 機密性とセキュリティ

5.1. 当事者は互いの機密情報を保護する義務がある
5.2. 顧客情報は機密に保持されなければならない
5.3. データセキュリティ基準が遵守されなければならない

6. 契約期間と終了

6.1. この契約は1年間有効である
6.2. 相互合意により延長される場合がある
6.3. 30日前の通知により終了される場合がある
6.4. 重大な違反の場合、即座に終了される場合がある

7. 紛争解決

7.1. 紛争は主に交渉を通じて解決が試みられる
7.2. 未解決の事件についてはトルコ共和国の裁判所が管轄権を持つ

8. 有効性

この契約は当事者によって読み、理解され、受け入れられました。`,
  'partnerlikSozlesmeOnay': '上記のINVAMEDパートナーシップ契約と条件を読み、理解し、受け入れます。この契約のすべての条項を受け入れ、義務を履行することを宣言します。',
  'sozlesmeyiGoruntule': '契約書を表示',
  'sozlesmeyiKapat': '閉じる',
  'Ürün': '製品',
  'Ürün eklemek için ürün listesinden seçim yapın': '製品リストから選択してカートに追加',
  'Etiketler': 'タグ',
  'Öncelikli': '優先',
  'Kapat': '閉じる',
  'globalPartnersTitle': '世界中の30,000のパートナーとの協力',
  'globalPartnersDesc': '私たちの広大な30,000のパートナーのグローバルネットワークは、共有イノベーション、知識交換、相互成功を推進しています。共に働くことで、患者ケアの境界を継続的に拡大しています。',
  'Yardım': 'ヘルプ',
  'dil': '言語',
  'Connect Free!': '無料で接続！',
  'En çok tercih edilen ürünlerimizi keşfedin': '私たちの人気製品を発見しましょう',
  'Tüm Kategoriler': 'すべてのカテゴリ',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48製品表示（合計：8000+）',
  'Tüm Ürünleri Gör →': 'すべての製品を見る →',
  'Detaylar': '詳細',
  'Sipariş Ver': '今すぐ注文',
  'Giriş Yap': 'ログイン',
  'Hesabınıza giriş yapın': 'アカウントにログイン',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'このサイトはreCAPTCHAで保護されており、Googleのプライバシーポリシーと利用規約が適用されます。',
  'Ürün Kataloğumuz': '私たちの製品カタログ',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': '8000以上の製品を提供しています',
  '1,3B': '1.3千',
  'Partner': 'パートナー',
  '8,4M': '840万',
  'Toplam Üretim': '総生産量',
  '23': '23',
  'Branş': '支店',
  '27,5B': '27.5千',
  'Toplam Sipariş': '総注文数',
  'Connect Now': '今すぐ接続',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'すべての情報に一箇所からアクセスするために無料で登録してください。',
  'Ürün Detayları': '製品詳細',
  'Kapat': '閉じる',
  'Yükleniyor...': '読み込み中...',
  'Hata': 'エラー',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}}製品表示（合計：8000+）',
  'Şehir Seçimi': '都市選択',
  'Firma / Sağlık Profesyoneli': '企業 / 医療専門家',
  'Yetkili Kişi': '担当者',
  'Telefon': '電話',
  'E-posta': 'メール',
  'Temel Bilgiler': '基本情報',
  'Ek Bilgiler': '追加情報',
  'Faaliyet Alanı / Sektör': '活動分野 / セクター',
  'Ülke Seçimi': '国選択',
  'Ülke adı veya kodu ara...': '国名またはコードを検索...',
  'region.Avrupa': 'ヨーロッパ',
  'region.Amerika': 'アメリカ',
  'region.Asya': 'アジア',
  'region.Afrika': 'アフリカ',
  'region.Okyanusya': 'オセアニア',
  'region.Diğer': 'その他',
  'country.TR': 'トルコ',
  'country.US': 'アメリカ合衆国',
  'country.DE': 'ドイツ',
  'country.FR': 'フランス',
  'country.GB': 'イギリス',
  'country.IT': 'イタリア',
  'country.ES': 'スペイン',
  'country.RU': 'ロシア',
  'country.CN': '中国',
  'country.JP': '日本',
  'country.KR': '韓国',
  'country.IN': 'インド',
  'country.BR': 'ブラジル',
  'country.CA': 'カナダ',
  'country.AU': 'オーストラリア',
  'Ticaret Sicil No': '商業登記番号',

  'country.TR': 'トルコ',
  'country.AL': 'アルバニア',
  'country.DE': 'ドイツ',
  'country.AD': 'アンドラ',
  'country.AT': 'オーストリア',
  'country.BY': 'ベラルーシ',
  'country.BE': 'ベルギー',
  'country.BA': 'ボスニア・ヘルツェゴビナ',
  'country.BG': 'ブルガリア',
  'country.CZ': 'チェコ共和国',
  'country.DK': 'デンマーク',
  'country.EE': 'エストニア',
  'country.FO': 'フェロー諸島',
  'country.FI': 'フィンランド',
  'country.FR': 'フランス',
  'country.GI': 'ジブラルタル',
  'country.GR': 'ギリシャ',
  'country.GG': 'ガーンジー',
  'country.HR': 'クロアチア',
  'country.NL': 'オランダ',
  'country.IE': 'アイルランド',
  'country.ES': 'スペイン',
  'country.SE': 'スウェーデン',
  'country.CH': 'スイス',
  'country.IT': 'イタリア',
  'country.IS': 'アイスランド',
  'country.JE': 'ジャージー',
  'country.ME': 'モンテネグロ',
  'country.LV': 'ラトビア',
  'country.LI': 'リヒテンシュタイン',
  'country.LT': 'リトアニア',
  'country.LU': 'ルクセンブルク',
  'country.HU': 'ハンガリー',
  'country.MT': 'マルタ',
  'country.IM': 'マン島',
  'country.MD': 'モルドバ',
  'country.MC': 'モナコ',
  'country.MK': '北マケドニア',
  'country.NO': 'ノルウェー',
  'country.PL': 'ポーランド',
  'country.PT': 'ポルトガル',
  'country.RO': 'ルーマニア',
  'country.RU': 'ロシア',
  'country.SM': 'サンマリノ',
  'country.RS': 'セルビア',
  'country.SK': 'スロバキア',
  'country.SI': 'スロベニア',
  'country.SJ': 'スバールバル・ヤンマイエン',
  'country.UA': 'ウクライナ',
  'country.GB': 'イギリス',
  'country.VA': 'バチカン',
  'country.AX': 'オーランド諸島',
  'country.US': 'アメリカ合衆国',
  'country.AS': 'アメリカ領サモア',
  'country.AI': 'アンギラ',
  'country.AG': 'アンティグア・バーブーダ',
  'country.AR': 'アルゼンチン',
  'country.AW': 'アルバ',
  'country.BS': 'バハマ',
  'country.BB': 'バルバドス',
  'country.BZ': 'ベリーズ',
  'country.BM': 'バミューダ',
  'country.BO': 'ボリビア',
  'country.BR': 'ブラジル',
  'country.VG': 'イギリス領ヴァージン諸島',
  'country.CA': 'カナダ',
  'country.KY': 'ケイマン諸島',
  'country.CL': 'チリ',
  'country.CO': 'コロンビア',
  'country.CR': 'コスタリカ',
  'country.CU': 'キューバ',
  'country.CW': 'キュラソー',
  'country.DM': 'ドミニカ',
  'country.DO': 'ドミニカ共和国',
  'country.EC': 'エクアドル',
  'country.SV': 'エルサルバドル',
  'country.FK': 'フォークランド諸島',
  'country.GF': 'フランス領ギアナ',
  'country.GD': 'グレナダ',
  'country.GL': 'グリーンランド',
  'country.GP': 'グアドループ',
  'country.GT': 'グアテマラ',
  'country.GY': 'ガイアナ',
  'country.HT': 'ハイチ',
  'country.HN': 'ホンジュラス',
  'country.JM': 'ジャマイカ',
  'country.MQ': 'マルティニーク',
  'country.MX': 'メキシコ',
  'country.MS': 'モントセラト',
  'country.NI': 'ニカラグア',
  'country.PA': 'パナマ',
  'country.PY': 'パラグアイ',
  'country.PE': 'ペルー',
  'country.PR': 'プエルトリコ',
  'country.BL': 'サン・バルテルミー',
  'country.KN': 'セント・キッツ・ネイビス',
  'country.LC': 'セント・ルシア',
  'country.MF': 'サン・マルタン',
  'country.PM': 'サン・ピエール・ミクロン',
  'country.VC': 'セント・ビンセント・グレナディーン',
  'country.SX': 'シント・マールテン',
  'country.SR': 'スリナム',
  'country.TT': 'トリニダード・トバゴ',
  'country.TC': 'タークス・カイコス諸島',
  'country.UY': 'ウルグアイ',
  'country.VE': 'ベネズエラ',
  'country.VI': 'アメリカ領ヴァージン諸島',
  'country.AF': 'アフガニスタン',
  'country.AZ': 'アゼルバイジャン',
  'country.BH': 'バーレーン',
  'country.BD': 'バングラデシュ',
  'country.AE': 'アラブ首長国連邦',
  'country.BN': 'ブルネイ',
  'country.BT': 'ブータン',
  'country.CN': '中国',
  'country.TL': '東ティモール',
  'country.ID': 'インドネシア',
  'country.AM': 'アルメニア',
  'country.PH': 'フィリピン',
  'country.PS': 'パレスチナ',
  'country.GE': 'ジョージア',
  'country.KR': '韓国',
  'country.IN': 'インド',
  'country.HK': '香港',
  'country.IQ': 'イラク',
  'country.IR': 'イラン',
  'country.IL': 'イスラエル',
  'country.JP': '日本',
  'country.KH': 'カンボジア',
  'country.QA': 'カタール',
  'country.KZ': 'カザフスタン',
  'country.KG': 'キルギス',
  'country.CY': 'キプロス',
  'country.KW': 'クウェート',
  'country.KP': '北朝鮮',
  'country.LA': 'ラオス',
  'country.LB': 'レバノン',
  'country.MO': 'マカオ',
  'country.MV': 'モルディブ',
  'country.MY': 'マレーシア',
  'country.MM': 'ミャンマー',
  'country.MN': 'モンゴル',
  'country.NP': 'ネパール',
  'country.UZ': 'ウズベキスタン',
  'country.PK': 'パキスタン',
  'country.SG': 'シンガポール',
  'country.LK': 'スリランカ',
  'country.SY': 'シリア',
  'country.SA': 'サウジアラビア',
  'country.TJ': 'タジキスタン',
  'country.TH': 'タイ',
  'country.TW': '台湾',
  'country.TM': 'トルクメニスタン',
  'country.OM': 'オマーン',
  'country.JO': 'ヨルダン',
  'country.VN': 'ベトナム',
  'country.YE': 'イエメン',
  'country.DZ': 'アルジェリア',
  'country.AO': 'アンゴラ',
  'country.BJ': 'ベナン',
  'country.BW': 'ボツワナ',
  'country.BF': 'ブルキナファソ',
  'country.BI': 'ブルンジ',
  'country.CV': 'カーボベルデ',
  'country.CM': 'カメルーン',
  'country.CF': '中央アフリカ共和国',
  'country.TD': 'チャド',
  'country.KM': 'コモロ',
  'country.CG': 'コンゴ共和国',
  'country.CD': 'コンゴ民主共和国',
  'country.CI': 'コートジボワール',
  'country.DJ': 'ジブチ',
  'country.EG': 'エジプト',
  'country.GQ': '赤道ギニア',
  'country.ER': 'エリトリア',
  'country.SZ': 'エスワティニ',
  'country.ET': 'エチオピア',
  'country.GA': 'ガボン',
  'country.GM': 'ガンビア',
  'country.GH': 'ガーナ',
  'country.GN': 'ギニア',
  'country.GW': 'ギニアビサウ',
  'country.KE': 'ケニア',
  'country.LS': 'レソト',
  'country.LR': 'リベリア',
  'country.LY': 'リビア',
  'country.MG': 'マダガスカル',
  'country.MW': 'マラウィ',
  'country.ML': 'マリ',
  'country.MR': 'モーリタニア',
  'country.MU': 'モーリシャス',
  'country.YT': 'マヨット',
  'country.MA': 'モロッコ',
  'country.MZ': 'モザンビーク',
  'country.NA': 'ナミビア',
  'country.NE': 'ニジェール',
  'country.NG': 'ナイジェリア',
  'country.RE': 'レユニオン',
  'country.RW': 'ルワンダ',
  'country.SH': 'セントヘレナ',
  'country.ST': 'サントメ・プリンシペ',
  'country.SN': 'セネガル',
  'country.SC': 'セーシェル',
  'country.SL': 'シエラレオネ',
  'country.SO': 'ソマリア',
  'country.ZA': '南アフリカ',
  'country.SS': '南スーダン',
  'country.SD': 'スーダン',
  'country.TZ': 'タンザニア',
  'country.TG': 'トーゴ',
  'country.TN': 'チュニジア',
  'country.UG': 'ウガンダ',
  'country.EH': '西サハラ',
  'country.ZM': 'ザンビア',
  'country.ZW': 'ジンバブエ',
  'country.AU': 'オーストラリア',
  'country.CX': 'クリスマス島',
  'country.CC': 'ココス諸島',
  'country.CK': 'クック諸島',
  'country.FJ': 'フィジー',
  'country.PF': 'フランス領ポリネシア',
  'country.GU': 'グアム',
  'country.HM': 'ハード島・マクドナルド諸島',
  'country.KI': 'キリバス',
  'country.MH': 'マーシャル諸島',
  'country.FM': 'ミクロネシア',
  'country.NR': 'ナウル',
  'country.NC': 'ニューカレドニア',
  'country.NZ': 'ニュージーランド',
  'country.NU': 'ニウエ',
  'country.NF': 'ノーフォーク島',
  'country.MP': '北マリアナ諸島',
  'country.PW': 'パラオ',
  'country.PG': 'パプアニューギニア',
  'country.PN': 'ピトケアン諸島',
  'country.WS': 'サモア',
  'country.SB': 'ソロモン諸島',
  'country.TK': 'トケラウ',
  'country.TO': 'トンガ',
  'country.TV': 'ツバル',
  'country.VU': 'バヌアツ',
  'country.WF': 'ウォリス・フツナ',
  'country.AQ': '南極',
  'country.BV': 'ブーベ島',
  'country.IO': 'イギリス領インド洋地域',
  'country.TF': 'フランス領南方・南極地域',
  'country.GS': 'サウスジョージア・サウスサンドウィッチ諸島',
};
